const DEFAULT_LOCALE = "en"
const SUPPORTED_LOCALES = ["en", "pt", "es", "fr", "de"]

module.exports = {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
}
